import React from 'react'
import Singlecategories from './Singlecategories'

const Categories = () => {
  return (
    <>

           <div id='display-phone'>
<h5 style={{borderBottom:'3px solid #B3DDEF',paddingLeft:'10px'}}>Shop from <span style={{color:'#B3DDEF',}}>Top Categories</span></h5>
<h5 style={{borderBottom:'3px solid black'}}>See All</h5>
 </div>
 <Singlecategories/>
        </>
  )
}

export default Categories